import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Club_PageMenu_ApiEnum } from './ClubDetailConfigApiInterface';

export enum Config_ClubPersons_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_ClubPersons_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'persons' = 'persons',
}

export enum Config_ClubPersons_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_ClubPersons_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_ClubPersons_ApiInterface
    extends ConfigDataInterface<
        Config_ClubPersons_Modules_ApiEnum,
        Config_ClubPersons_ActionsMenu_ApiEnum,
        Config_ClubPersons_ActionsOther_ApiEnum,
        Config_Club_PageMenu_ApiEnum,
        Config_ClubPersons_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
